/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsPencilArrowRight: {
  name: 'pencil-arrow-right';
  data: string;
} = {
  name: 'pencil-arrow-right',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.586 4a2 2 0 0 1 2.828 0L18 6.586l-.707.707.707-.707a2 2 0 0 1 0 2.828L9.455 17.96a2 2 0 0 1-1.193.574l-2.91.323a2 2 0 0 1-2.208-2.209l.323-2.909a2 2 0 0 1 .574-1.193l6.246-6.246.006-.006.006-.006L12.586 4Zm-7.13 9.96L11 8.413 13.586 11 8.04 16.545l-2.91.323.324-2.909ZM16.585 8 15 9.586 12.414 7 14 5.414 16.586 8Zm4.121 9.293-2-2a1 1 0 1 0-1.414 1.414l.293.293H14a1 1 0 1 0 0 2h3.586l-.293.293a1 1 0 1 0 1.414 1.414l2-2a1 1 0 0 0 0-1.414Z" fill="currentColor"/></svg>`,
};
